// Date and money formatting helpers.

const moneyFmt = new Intl.NumberFormat("pl-PL", {
  style: "currency",
  currency: "PLN",
  maximumFractionDigits: 2,
});

export const money = (n: number) => moneyFmt.format(n);

/** Parse a "YYYY-MM-DD" string as a local Date (no timezone shifting). */
export function parseDate(s: string): Date {
  const [y, m, d] = s.split("-").map(Number);
  return new Date(y ?? 1970, (m ?? 1) - 1, d ?? 1);
}

/** Format a Date as "YYYY-MM-DD" (local). */
export function isoDate(d: Date): string {
  const y = d.getFullYear();
  const m = `${d.getMonth() + 1}`.padStart(2, "0");
  const day = `${d.getDate()}`.padStart(2, "0");
  return `${y}-${m}-${day}`;
}

export const todayISO = () => isoDate(new Date());

export function addDays(d: Date, n: number): Date {
  const r = new Date(d);
  r.setDate(r.getDate() + n);
  return r;
}

const dayFmt = new Intl.DateTimeFormat("en-US", { weekday: "short", month: "short", day: "numeric" });
const longDayFmt = new Intl.DateTimeFormat("en-US", { weekday: "long", month: "long", day: "numeric" });
const weekdayFmt = new Intl.DateTimeFormat("en-US", { weekday: "short" });

export const fmtDay = (s: string) => dayFmt.format(parseDate(s));
export const fmtLongDay = (d: Date) => longDayFmt.format(d);
export const fmtWeekday = (s: string) => weekdayFmt.format(parseDate(s));

/** Friendly relative label for a due/﻿event date. */
export function relativeDay(s: string): string {
  const target = parseDate(s);
  const now = new Date();
  const start = new Date(now.getFullYear(), now.getMonth(), now.getDate());
  const diff = Math.round((target.getTime() - start.getTime()) / 86_400_000);
  if (diff === 0) return "Today";
  if (diff === 1) return "Tomorrow";
  if (diff === -1) return "Yesterday";
  if (diff > 1 && diff < 7) return `In ${diff} days`;
  if (diff < 0) return `${Math.abs(diff)} days ago`;
  return fmtDay(s);
}
